export default "__VITE_ASSET__72f126a3__"